/**
 * ENG-2384: Sam's guide to the new scheduler (Drive, shared "anyone with the link"). One
 * constant so it can be repointed, kept in the app shell because the classic offer banner,
 * which is in the main bundle, links to it as well as V3's side panel.
 */
export const SCHEDULER_GUIDE_URL =
  "https://drive.google.com/file/d/1Af1ARKwLvsAQQkUWDdb47jyrvddWgrYH/view";

/** Every guide link opens a new tab, so the schedule stays where it was. */
export const GUIDE_LINK_TARGET = {
  target: "_blank",
  rel: "noopener noreferrer"
} as const;
